/* import __COLOCATED_TEMPLATE__ from './fin-spam-notification.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type Conversation from 'embercom/objects/inbox/conversation';

interface Args {
  conversation: Conversation;
  onMarkAsNotSpam: () => void;
}

interface Signature {
  Args: Args;
}

export default class FinSpamNotification extends Component<Signature> {
  @service declare session: Session;

  get guidanceRoute() {
    if (this.session.workspace.isStandaloneApp) {
      return 'apps.app.standalone.guidance';
    }
    return 'apps.app.automation.fin-ai-agent.guidance';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationPage::FinSpamNotification': typeof FinSpamNotification;
    'inbox2/conversation-page/fin-spam-notification': typeof FinSpamNotification;
  }
}
